import { WorldPayResponse } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromWorldPay from '../actions/worldpay.action';
import { StateSlice } from '@core/helpers/state-slice';

export type WorldPayState = StateSlice<WorldPayResponse>;

export const initialState: WorldPayState = {
  data: {} as WorldPayResponse,
  loaded: false,
  loading: false,
  error: null,
};

const createOrderReducer = createReducer(
  initialState,
  on(fromWorldPay.loadWorldPay, () => ({
    ...initialState,
    loading: false,
  })),
  on(fromWorldPay.loadWorldPaySuccess, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  }),
  on(fromWorldPay.loadWorldPayFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
    };
  }),
  on(fromWorldPay.resetWorldPay, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: WorldPayState | undefined,
  action: fromWorldPay.WorldPayActions
) {
  return createOrderReducer(state, action);
}
